const filled = (nodes, viewBox = '0 0 24 24') =>
  Object.freeze({
    viewBox,
    fill: 'currentColor',
    stroke: 'none',
    nodes: Object.freeze(nodes)
  })

const outlined = (nodes, options = {}) =>
  Object.freeze({
    viewBox: options.viewBox || '0 0 24 24',
    fill: options.fill || 'none',
    stroke: options.stroke || 'currentColor',
    strokeWidth: options.strokeWidth || 1.5,
    strokeLinecap: options.strokeLinecap || 'round',
    strokeLinejoin: options.strokeLinejoin || 'round',
    nodes: Object.freeze(nodes)
  })

const profileNodes = [
  { tag: 'circle', attrs: { cx: 12, cy: 7, r: 4, fill: 'currentColor' } },
  {
    tag: 'path',
    attrs: {
      d: 'M5 16.9347C5 16.0743 5.54085 15.3068 6.35109 15.0175C10.004 13.7128 13.996 13.7128 17.6489 15.0175C18.4591 15.3068 19 16.0743 19 16.9347V18.2502C19 19.4376 17.9483 20.3498 16.7728 20.1818L15.8184 20.0455C13.2856 19.6837 10.7144 19.6837 8.18162 20.0455L7.22721 20.1818C6.0517 20.3498 5 19.4376 5 18.2502V16.9347Z',
      fill: 'currentColor'
    }
  }
]

export const defaultIcons = Object.freeze({
  dashboard: outlined(
    [
      {
        tag: 'path',
        attrs: {
          d: 'M11 6C11 5.44772 10.5506 4.99356 10.0026 5.06242C8.77376 5.21683 7.59275 5.65513 6.55544 6.34824C5.23985 7.22729 4.21446 8.47672 3.60896 9.93853C3.00346 11.4003 2.84504 13.0089 3.15372 14.5607C3.4624 16.1126 4.22433 17.538 5.34315 18.6569C6.46197 19.7757 7.88743 20.5376 9.43928 20.8463C10.9911 21.155 12.5997 20.9965 14.0615 20.391C15.5233 19.7855 16.7727 18.7602 17.6518 17.4446C18.3449 16.4072 18.7832 15.2262 18.9376 13.9974C19.0064 13.4494 18.5523 13 18 13H12.5C11.6716 13 11 12.3284 11 11.5V6Z',
          fill: 'currentColor'
        }
      },
      {
        tag: 'path',
        attrs: {
          d: 'M14 4C14 3.44772 14.45 2.99268 14.9966 3.07131C15.5731 3.15423 16.1383 3.30896 16.6788 3.53284C17.5281 3.88463 18.2997 4.40024 18.9497 5.05025C19.5998 5.70026 20.1154 6.47194 20.4672 7.32122C20.691 7.86171 20.8458 8.4269 20.9287 9.00339C21.0073 9.55005 20.5523 10 20 10H14.2C14.0895 10 14 9.91046 14 9.8V4Z',
          fill: 'currentColor'
        }
      }
    ],
    { strokeWidth: 1.5, strokeLinecap: 'butt', strokeLinejoin: 'miter' }
  ),
  reports: filled([
    {
      tag: 'path',
      attrs: {
        d: 'M21 7.5C19.067 7.5 17.5 5.933 17.5 4C17.5 3.00523 17.915 2.1074 18.5813 1.47018C18.0789 1.32678 17.5484 1.25 17 1.25H7C3.82436 1.25 1.25 3.82436 1.25 7V17C1.25 20.1756 3.82436 22.75 7 22.75H17C20.1756 22.75 22.75 20.1756 22.75 17V7.03176C22.2352 7.32956 21.6375 7.5 21 7.5ZM6.50612 15.3144C6.19439 15.0417 6.16281 14.5678 6.43557 14.2561L9.93557 10.2561C10.2037 9.94969 10.6673 9.91317 10.9801 10.1738L13.4177 12.2051L16.4356 8.75612C16.7083 8.44439 17.1822 8.41281 17.4939 8.68557C17.8056 8.95833 17.8372 9.43215 17.5644 9.74388L14.0644 13.7439C13.7963 14.0503 13.3327 14.0868 13.0199 13.8262L10.5823 11.7949L7.56443 15.2439C7.29167 15.5556 6.81785 15.5872 6.50612 15.3144Z',
        'fill-rule': 'evenodd',
        'clip-rule': 'evenodd'
      }
    },
    {
      tag: 'path',
      attrs: {
        d: 'M20.1502 2.18898C21.2617 2.91826 22.1053 4.02236 22.5012 5.32158C22.1347 5.73756 21.598 6 21 6C19.8954 6 19 5.10457 19 4C19 3.19927 19.4706 2.50844 20.1502 2.18898Z'
      }
    },
    {
      tag: 'path',
      attrs: {
        d: 'M19 4C19 5.10457 19.8954 6 21 6C22.1046 6 23 5.10457 23 4C23 2.89543 22.1046 2 21 2C19.8954 2 19 2.89543 19 4Z'
      }
    }
  ]),
  trade: outlined(
    [
      {
        tag: 'path',
        attrs: {
          d: 'M8.00009 19L5.7072 16.7071C5.31668 16.3166 5.31668 15.6834 5.7072 15.2929L8.00009 13M6.00009 16L18.0001 16'
        }
      },
      {
        tag: 'path',
        attrs: {
          d: 'M16.4697 9.46967C16.1768 9.76256 16.1768 10.2374 16.4697 10.5303C16.7626 10.8232 17.2374 10.8232 17.5303 10.5303L16.4697 9.46967ZM19.2929 7.70711L18.7626 7.17678V7.17678L19.2929 7.70711ZM19.2929 6.29289L19.8232 5.76256L19.8232 5.76256L19.2929 6.29289ZM17.5303 3.46967C17.2374 3.17678 16.7626 3.17678 16.4697 3.46967C16.1768 3.76256 16.1768 4.23744 16.4697 4.53033L17.5303 3.46967ZM19 7.75C19.4142 7.75 19.75 7.41421 19.75 7C19.75 6.58579 19.4142 6.25 19 6.25V7.75ZM7 6.25C6.58579 6.25 6.25 6.58578 6.25 7C6.25 7.41421 6.58579 7.75 7 7.75L7 6.25ZM17.5303 10.5303L19.8232 8.23744L18.7626 7.17678L16.4697 9.46967L17.5303 10.5303ZM19.8232 5.76256L17.5303 3.46967L16.4697 4.53033L18.7626 6.82322L19.8232 5.76256ZM19.8232 8.23744C20.5066 7.55402 20.5066 6.44598 19.8232 5.76256L18.7626 6.82322C18.8602 6.92085 18.8602 7.07914 18.7626 7.17678L19.8232 8.23744ZM19 6.25L7 6.25L7 7.75L19 7.75V6.25Z',
          fill: 'currentColor',
          stroke: 'none'
        }
      }
    ],
    { strokeLinejoin: 'miter' }
  ),
  orders: outlined([
    { tag: 'path', attrs: { d: 'M21 7H11M3 17H13' } },
    { tag: 'circle', attrs: { cx: 5, cy: 7, r: 2, fill: 'var(--color-neutral)' } },
    { tag: 'circle', attrs: { cx: 19, cy: 17, r: 2, fill: 'var(--color-neutral)' } }
  ]),
  profile: outlined(profileNodes, { strokeLinecap: 'butt', strokeLinejoin: 'miter' }),
  admin: outlined(profileNodes, { strokeLinecap: 'butt', strokeLinejoin: 'miter' }),
  return: outlined(
    [
      {
        tag: 'path',
        attrs: {
          d: 'M16 16L19.2929 12.7071C19.6834 12.3166 19.6834 11.6834 19.2929 11.2929L16 8M19 12H5'
        }
      }
    ],
    { strokeLinejoin: 'miter' }
  ),
  home: filled(
    [
      {
        tag: 'path',
        attrs: {
          d: 'M487.083 225.514L412.003 150.434V63.704C412.003 48.022 399.295 35.313 383.59 35.313C367.921 35.313 355.213 48.022 355.213 63.704V93.645L299.31 37.74C271.671 10.116 223.616 10.165 196.04 37.79L8.312 225.514C-2.77 236.618-2.77 254.585 8.312 265.672C19.399 276.773 37.401 276.773 48.484 265.672L236.194 77.943C242.309 71.86 253.087 71.86 259.17 77.925L446.912 265.672C452.479 271.223 459.737 273.984 466.993 273.984C474.264 273.984 481.534 271.22 487.084 265.672C498.17 254.586 498.17 236.619 487.083 225.514Z'
        }
      },
      {
        tag: 'path',
        attrs: {
          d: 'M257.561 131.836C252.107 126.385 243.276 126.385 237.838 131.836L72.712 296.913C70.105 299.519 68.627 303.077 68.627 306.79V427.191C68.627 455.444 91.535 478.351 119.787 478.351H201.541V351.741H293.84V478.351H375.595C403.846 478.351 426.754 455.444 426.754 427.192V306.79C426.754 303.077 425.289 299.519 422.669 296.913L257.561 131.836Z'
        }
      }
    ],
    '0 0 495.398 495.398'
  ),
  language: outlined(
    [
      { tag: 'circle', attrs: { cx: 12, cy: 12, r: 10 } },
      {
        tag: 'path',
        attrs: {
          d: 'M12 22C14.6667 19.5758 16 16.2424 16 12C16 7.75758 14.6667 4.42424 12 2C9.33333 4.42424 8 7.75758 8 12C8 16.2424 9.33333 19.5758 12 22Z'
        }
      },
      { tag: 'path', attrs: { d: 'M2.5 9H21.5M2.5 15H21.5' } }
    ],
    { strokeWidth: 1.2 }
  ),
  avatar: filled(
    [
      {
        tag: 'path',
        attrs: {
          d: 'M23.5998 6C18.2974 6 13.9998 10.2976 13.9998 15.6V17.2C13.9998 22.5024 18.2974 26.8 23.5998 26.8C28.9022 26.8 33.1998 22.5024 33.1998 17.2V15.6C33.1998 10.2976 28.9022 6 23.5998 6ZM17.356 32.4844C12.66 33.7116 8.23025 36.0221 6.59665 38.1469C5.13425 40.0477 6.52638 42.8 8.92478 42.8H38.2717C40.6701 42.8 42.0622 40.0462 40.5998 38.1438C38.9662 36.019 34.5379 33.7116 29.8435 32.4844C28.1635 33.926 25.9854 34.8 23.5998 34.8C21.2126 34.8 19.036 33.9244 17.356 32.4844Z',
          fill: '#7C8698'
        }
      }
    ],
    '0 0 48 48'
  ),
  'chevron-right': outlined([{ tag: 'path', attrs: { d: 'M10 7L15 12L10 17' } }]),
  'two-factor': outlined([
    { tag: 'rect', attrs: { x: 4, y: 10, width: 12, height: 11, rx: 2 } },
    { tag: 'path', attrs: { d: 'M7 10V7C7 4.8 8.8 3 11 3C13.2 3 15 4.8 15 7V10' } },
    { tag: 'path', attrs: { d: 'M17 16L19 18L22 14' } }
  ]),
  'service-bot': outlined([
    { tag: 'rect', attrs: { x: 4, y: 7, width: 16, height: 13, rx: 3 } },
    { tag: 'path', attrs: { d: 'M12 7V4M9 4H15' } },
    { tag: 'circle', attrs: { cx: 9, cy: 13, r: 1, fill: 'currentColor', stroke: 'none' } },
    { tag: 'circle', attrs: { cx: 15, cy: 13, r: 1, fill: 'currentColor', stroke: 'none' } },
    { tag: 'path', attrs: { d: 'M9 17H15' } }
  ]),
  calendar: outlined([
    { tag: 'rect', attrs: { x: 3, y: 5, width: 18, height: 16, rx: 2 } },
    { tag: 'path', attrs: { d: 'M7 3V7M17 3V7M3 10H21M7 14H10M14 14H17M7 18H10' } }
  ]),
  devices: outlined([
    { tag: 'rect', attrs: { x: 2, y: 4, width: 15, height: 12, rx: 2 } },
    { tag: 'path', attrs: { d: 'M5 20H14M8 16V20M18 8H22V20H16V18' } }
  ]),
  terms: outlined([
    { tag: 'path', attrs: { d: 'M6 3H14L19 8V21H6V3Z' } },
    { tag: 'path', attrs: { d: 'M14 3V8H19M9 13L11 15L15 11M9 18H16' } }
  ]),
  referral: outlined([
    { tag: 'circle', attrs: { cx: 6, cy: 12, r: 2.5 } },
    { tag: 'circle', attrs: { cx: 17, cy: 6, r: 2.5 } },
    { tag: 'circle', attrs: { cx: 17, cy: 18, r: 2.5 } },
    { tag: 'path', attrs: { d: 'M8.25 10.75L14.75 7.25M8.25 13.25L14.75 16.75' } }
  ]),
  api: outlined([{ tag: 'path', attrs: { d: 'M8 7L3 12L8 17M16 7L21 12L16 17M14 4L10 20' } }]),
  logout: outlined([
    {
      tag: 'path',
      attrs: {
        d: 'M16 16V18C16 20.2091 14.2091 22 12 22H7C4.79086 22 3 20.2091 3 18V6C3 3.79086 4.79086 2 7 2H12C14.2091 2 16 3.79086 16 6V8'
      }
    },
    {
      tag: 'path',
      attrs: {
        d: 'M19 15L21.2929 12.7071C21.6834 12.3166 21.6834 11.6834 21.2929 11.2929L19 9M21 12H9'
      }
    }
  ]),
  'status-success': outlined([
    { tag: 'circle', attrs: { cx: 12, cy: 12, r: 9 } },
    { tag: 'path', attrs: { d: 'M8 12L11 15L16.5 9' } }
  ]),
  'status-info': outlined([
    { tag: 'circle', attrs: { cx: 12, cy: 12, r: 9 } },
    { tag: 'path', attrs: { d: 'M12 10V16' } },
    { tag: 'circle', attrs: { cx: 12, cy: 7, r: 0.8, fill: 'currentColor', stroke: 'none' } }
  ]),
  'status-warning': outlined([
    { tag: 'path', attrs: { d: 'M12 3L22 20H2L12 3Z' } },
    { tag: 'path', attrs: { d: 'M12 9V14' } },
    { tag: 'circle', attrs: { cx: 12, cy: 17, r: 0.8, fill: 'currentColor', stroke: 'none' } }
  ]),
  'status-danger': outlined([
    { tag: 'circle', attrs: { cx: 12, cy: 12, r: 9 } },
    { tag: 'path', attrs: { d: 'M9 9L15 15M15 9L9 15' } }
  ]),
  'crypto-transfer': outlined([
    {
      tag: 'path',
      attrs: {
        d: 'M18 5.5C18 6.88071 14.866 8 11 8C7.13401 8 4 6.88071 4 5.5M18 5.5C18 4.11929 14.866 3 11 3C7.13401 3 4 4.11929 4 5.5M18 5.5V8.5M4 5.5V17.5C4 18.7595 6.60771 19.8014 10 19.9747M4 9.5C4 10.7595 6.60771 11.8014 10 11.9747M4 13.5C4 14.6325 6.10851 15.5891 9 15.8965'
      }
    },
    { tag: 'path', attrs: { d: 'M14 16H18M16 14V18' } },
    { tag: 'circle', attrs: { cx: 16, cy: 16, r: 5 } }
  ]),
  'cash-transfer': outlined([
    {
      tag: 'path',
      attrs: {
        d: 'M21.4996 12.1746V7.07322C21.4996 6.20436 20.7161 5.5 19.7496 5.5H14.075M20.2622 6.61244L11.6001 14.3995'
      }
    },
    {
      tag: 'path',
      attrs: {
        d: 'M2.60002 11.7248V16.8262C2.60002 17.6951 3.38352 18.3994 4.35001 18.3994H10.0246M3.83745 17.287L12.4995 9.49992'
      }
    }
  ]),
  'cta-arrow': outlined([{ tag: 'path', attrs: { d: 'M5 12H19M13 6L19 12L13 18' } }]),
  check: outlined([{ tag: 'path', attrs: { d: 'M5 12L9 16L19 6' } }]),
  'device-mobile': outlined([
    { tag: 'rect', attrs: { x: 7, y: 2, width: 10, height: 20, rx: 2 } },
    { tag: 'path', attrs: { d: 'M11 18H13' } }
  ]),
  'device-laptop': outlined([
    { tag: 'rect', attrs: { x: 4, y: 4, width: 16, height: 12, rx: 2 } },
    { tag: 'path', attrs: { d: 'M2 20H22M8 16L7 20M16 16L17 20' } }
  ]),
  copy: outlined([
    { tag: 'rect', attrs: { x: 5, y: 3, width: 10, height: 14, rx: 3 } },
    {
      tag: 'path',
      attrs: {
        d: 'M17.5 7.40137C18.3967 7.92008 19 8.8896 19 10V18C19 19.6569 17.6569 21 16 21H12C10.8896 21 9.92008 20.3967 9.40137 19.5'
      }
    }
  ])
})
